import {
  and,
  curry,
  getPath,
  hasPropPath,
  identity,
  ifElse,
  isArray,
  isDefined,
  isObject,
} from 'crocks';

export const prepareThrow = message => () => {
  throw new Error(message);
}

export const prepareCustomThrow = message => () => {
  throw message;
}

/**
 * @param {function} fallback A fallback function to run when no case resolves.
 * @param {Array<function, function>} caseMap An array of case-arrays [predicate function, resolving function].
 * @param {any} value A value to test with provided cases.
 * @returns any
 */
export const caseMap = curry((fallback, caseMap, value) => ifElse(
  isArray,
  () => ifElse(
    isDefined,
    ([_, fn]) => fn(value),
    () => fallback(value),
    caseMap.find(([pred]) => pred(value))
  ),
  prepareThrow('caseMap arguments must be #1 fallback fn, #2 array of cases, #3 any.'),
  caseMap
));

export const throwPath = curry(
  (path, object) => ifElse(
    and(isObject, hasPropPath(path)),
    (obj) => { throw getPath(path, obj).option(obj) },
    identity,
    object,
  )
);
